import { GeneralTypeInterface } from '../interfaces/Dto/GeneralTypeInterface'
import axios from 'axios'
import { ListResponse } from '../interfaces/Shipment/ListResponseDto'
import {
  ApplicationDjangoDto,
  AreaCodeDjangoDto,
  PhoneTypeDjangoDto,
} from '../interfaces/Django/CatalogDjangoDto'
import { apiDjango } from './ApiDjango'

const { REACT_APP_URL_PATH_API, REACT_APP_URL_PATH_API_DJANGO } = process.env

export const GeneralTypePhoneServices = async (
  CountryId: string
): Promise<ListResponse<GeneralTypeInterface>> => {
  try {
    const response = await axios.get(
      `${REACT_APP_URL_PATH_API}/ListofType/listCodePhone?CountryId=${CountryId}`
    )
    if (response.status === 200) {
      var datamap = response.data
      return datamap
    }
  } catch (error) {}

  return [] as unknown as ListResponse<GeneralTypeInterface>
}

/**
 * GET /api/area-code (Django) — prefijos de operadora / codigos de area del pais.
 * Reemplaza el .NET ListofType/listCodePhone. Drop-in: devuelve { value, text } para el
 * dropdown "Operadora".
 *
 * `area_code` llega CON cero inicial ("0212", "0412"); se quita porque todo el manejo de
 * telefono del front trabaja sin el (obtenerCodigoArea devuelve "412", tryParsePastedPhone
 * matchea contra el codigo sin 0, y la validacion exige operadora + 7 = 10 digitos).
 * `countryCode` es el codigo telefonico (58), NO el CountryId .NET (236). NO lanza.
 */
export const getAreaCodesDjango = async (
  countryCode?: string
): Promise<ListResponse<GeneralTypeInterface[]>> => {
  const errMsg = 'No se pudieron obtener los codigos de area'
  try {
    const resp = await apiDjango.get(
      `${REACT_APP_URL_PATH_API_DJANGO}/area-code`,
      { params: countryCode ? { country_code: countryCode } : undefined }
    )
    if (resp.status === 200 && resp.data && resp.data.error === false) {
      const list = (resp.data.data ?? []) as AreaCodeDjangoDto[]
      return {
        model: list.map((dto) => {
          const raw = (dto.area_code ?? '').trim()
          const code = raw.startsWith('0') ? raw.slice(1) : raw
          return { value: code, text: code }
        }),
        didError: false,
        message: resp.data.message ?? '',
        errorMessage: '',
      }
    }
    const m = resp.data?.message || errMsg
    console.error('getAreaCodesDjango: respuesta con error', {
      code: resp.data?.code,
      message: resp.data?.message,
    })
    return { model: null, didError: true, message: m, errorMessage: m }
  } catch (error) {
    const m = (error as any)?.response?.data?.message || errMsg
    console.error('getAreaCodesDjango: fallo', { error })
    return { model: null, didError: true, message: m, errorMessage: m }
  }
}

/**
 * GET /api/phone-type (Django) — tipos de telefono del pais.
 * Drop-in de GeneralTypePhoneServices: mismo retorno { value, text } para alimentar los
 * dropdowns existentes. `value` = phone_type_code, `text` = phone_type_name.
 * Envelope Django: { code, error, message, data, error_data }. NO lanza.
 */
export const getPhoneTypesDjango = async (
  countryCode?: string
): Promise<ListResponse<GeneralTypeInterface[]>> => {
  const errMsg = 'No se pudieron obtener los tipos de telefono'
  try {
    const resp = await apiDjango.get(
      `${REACT_APP_URL_PATH_API_DJANGO}/phone-type`,
      { params: countryCode ? { country_code: countryCode } : undefined }
    )
    if (resp.status === 200 && resp.data && resp.data.error === false) {
      const list = (resp.data.data ?? []) as PhoneTypeDjangoDto[]
      return {
        model: list.map((dto) => ({
          value: dto.phone_type_code,
          text: dto.phone_type_name,
        })),
        didError: false,
        message: resp.data.message ?? '',
        errorMessage: '',
      }
    }
    const m = resp.data?.message || errMsg
    console.error('getPhoneTypesDjango: respuesta con error', {
      code: resp.data?.code,
      message: resp.data?.message,
    })
    return { model: null, didError: true, message: m, errorMessage: m }
  } catch (error) {
    const m = (error as any)?.response?.data?.message || errMsg
    console.error('getPhoneTypesDjango: fallo', { error })
    return { model: null, didError: true, message: m, errorMessage: m }
  }
}

/**
 * GET /api/application (Django) — busca aplicaciones.
 * OJO: los filtros son exact match (no parcial): application_name=Web NO encuentra
 * "Web Portal"; hay que mandar el nombre completo. NO lanza.
 */
export const getApplicationsDjango = async (params?: {
  application_id?: number
  application_code?: string
  application_name?: string
}): Promise<ListResponse<ApplicationDjangoDto[]>> => {
  const errMsg = 'No se pudieron obtener las aplicaciones'
  try {
    const resp = await apiDjango.get(
      `${REACT_APP_URL_PATH_API_DJANGO}/application`,
      { params }
    )
    if (resp.status === 200 && resp.data && resp.data.error === false) {
      return {
        model: (resp.data.data ?? []) as ApplicationDjangoDto[],
        didError: false,
        message: resp.data.message ?? '',
        errorMessage: '',
      }
    }
    const m = resp.data?.message || errMsg
    console.error('getApplicationsDjango: respuesta con error', {
      code: resp.data?.code,
      message: resp.data?.message,
    })
    return { model: null, didError: true, message: m, errorMessage: m }
  } catch (error) {
    const m = (error as any)?.response?.data?.message || errMsg
    console.error('getApplicationsDjango: fallo', { error })
    return { model: null, didError: true, message: m, errorMessage: m }
  }
}
